<div class="content"
  role="main">
  <div class="breadcrumb-container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb breadcrumb-chevron p-3 bg-body-tertiary rounded-3">
        <li class="breadcrumb-item">
          <a class="link-body-emphasis text-decoration-none"
            routerLink="/deployments">
            <span class="">Deployments</span>
          </a>
        </li>
        <li class="breadcrumb-item">
          <a class="link-body-emphasis text-decoration-none"
          routerLink="/deployments/{{deploymentId}}">{{deploymentName}}</a>
        </li>
        <li class="breadcrumb-item active">
          <span class="link-body-emphasis fw-normal">
            Status Updates
          </span>
        </li>
      </ol>
    </nav>
  </div>
  <!-- <h2 class="pageName">Status History</h2> -->
  <!--<pre>Deployments list has: *{{ deploymentList | json }}*</pre>-->
  <div class="menu">
    @if (statusSummaries && statusSummaries.length > 0) {
      <button
        class="btn btn-sm btn-outline-danger float-end"
      (click)="deleteAllStatusSummaries()">Delete All History</button>
    }
  </div>
  <div class="statusTable">
    @if (statusSummaries && statusSummaries.length > 0) {
      <table>
        <thead>
          <tr>
            <th>Install Date</th>
            <th>Code Version</th>
            <th>DB Version</th>
          </tr>
        </thead>
        <tbody>
          @for (summary of statusSummaries; track summary) {
            <tr class="header-row">
              <td>{{summary.statusDate}}</td>
              <td>{{summary.codeVersion}}</td>
              <td>{{summary.dbVersion}}</td>
              <td>
                <button class="btn btn-link"
                  (click)="deleteStatusSummary(summary)">
                  Delete
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <table class="tenant-status-table">
                  @for (tsu of summary.tenantStatusUpdates; track tsu) {
                    <tr>
                      <td>{{tsu.name}}</td>
                      <td>{{tsu.modifiedDate | date:'MM/dd/yyyy'}}</td>
                      <td>#S:{{tsu.subjectCount}}</td>
                      <td>#U:{{tsu.userCount}}</td>
                      <td>DB: {{tsu.isCurrentDb ? 'Current': tsu.dbVersion}}
                      </td>
                      <td>Data: {{!tsu.dataValidationResult ? 'N/A' : tsu.dataValidationResult}}
                      </td>
                    </tr>
                  }
                </table>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    @if (!statusSummaries || statusSummaries.length === 0) {
      <div
        class="statusTable">
        <p>No status history found.</p>
      </div>
    }
  </div>
</div>